import { gql } from "@apollo/client";

// Spark agent mutations
export const CREATE_AGENT = gql`
  mutation CreateAgent($input: CreateAgentInput!) {
    createAgent(input: $input) {
      agent {
        id
        type
        category
        engineId
        name
        domain
        description
        status
        buttonNames
        role
        systemPreferences
        defaultPrompt
        temperature
        maxTokens
        onlineSources {
          url
          description
        }
        fileSourceUrls {
          url
          description
        }
        inputSchema
        outputSchema
        tools
        isPublic
        createdAt
        updatedAt
      }
    }
  }
`;

export const UPDATE_AGENT = gql`
  mutation UpdateAgent($input: UpdateAgentInput!) {
    updateAgent(input: $input) {
      agent {
        id
        type
        category
        engineId
        name
        domain
        description
        status
        buttonNames
        role
        systemPreferences
        defaultPrompt
        temperature
        maxTokens
        onlineSources {
          url
          description
        }
        fileSourceUrls {
          url
          description
        }
        inputSchema
        outputSchema
        tools
        isPublic
        createdAt
        updatedAt
      }
    }
  }
`;

export const DELETE_AGENT = gql`
  mutation DeleteAgent($id: ID!) {
    deleteAgent(id: $id) {
      success
      message
      id
    }
  }
`;

export const SYNC_AGENT_FILES = gql`
  mutation SyncAgentFiles($input: SyncAgentFilesInput!) {
    syncAgentFiles(input: $input) {
      agent {
        id
        name
        openaiFiles {
          id
          openaiFileId
          s3Url
          name
          size
          uploadedAt
        }
        updatedAt
      }
    }
  }
`;

export const SYNC_AGENT_ASSISTANT = gql`
  mutation SyncAgentAssistant($input: SyncAgentAssistantInput!) {
    syncAgentAssistant(input: $input) {
      agent {
        id
        name
        openaiAssistantId
        openaiVectorStoreId
        updatedAt
      }
      assistantId
      vectorStoreId
    }
  }
`;

// Chat with Spark agent mutation
export const CHAT_WITH_SPARK_AGENT = gql`
  mutation ChatWithAgent($input: ChatWithAgentInput!) {
    chatWithAgent(input: $input) {
      threadId
      messageId
      content
      role
      annotations
    }
  }
`;

// Chat with agent in the context of a contact
export const CHAT_WITH_AGENT_CONTACT = gql`
  mutation ChatWithAgentContact($input: ChatWithAgentContactInput!) {
    chatWithAgentContact(input: $input) {
      response
      threadId
      qnaId
    }
  }
`;

// Legacy mutations for PageMyRightHand (old OpenAI-based agent system)
// These use a different agent schema than the new Spark agent system
export const CHAT_WITH_AGENT = gql`
  mutation ChatWithAgent($input: ChatWithAgentInput!) {
    chatWithAgent(input: $input) {
      threadId
      messageId
      content
      role
      annotations
    }
  }
`;

export const RECONFIGURE_AGENT = gql`
  mutation ReconfigureAgent($input: ReconfigureAgentInput!) {
    reconfigureAgent(input: $input) {
      agent {
        id
        taskId
        openaiAssistantId
        openaiVectorStoreId
        name
        description
        systemPreference
        inputParameters
        outputParameters
        files {
          id
          openaiFileId
          name
          size
          mimeType
          uploadedAt
        }
        model
        tools
        status
        domain
        locationId
        createdBy
        timestamp
        updatedAt
      }
    }
  }
`;

export const UPDATE_AGENT_FILES = gql`
  mutation UpdateAgentFiles($input: UpdateAgentFilesInput!) {
    updateAgentFiles(input: $input) {
      agent {
        id
        taskId
        openaiAssistantId
        openaiVectorStoreId
        name
        description
        systemPreference
        inputParameters
        outputParameters
        files {
          id
          openaiFileId
          name
          size
          mimeType
          uploadedAt
        }
        model
        tools
        status
        domain
        locationId
        createdBy
        timestamp
        updatedAt
      }
    }
  }
`;
